<template>
  <div class="Income-and-expenditureEdit">
    <div class="right">
      <el-container class="top">
        <el-header class="first-line"
                   style="height: 38px;">
          <span>年收入(元)</span>
          <span>本人</span>
          <span>配偶</span>
        </el-header>
        <el-main class="content">
          <div v-for="(v,i) in incomeTableData"
               :key="i"
               :class="i%2!==0?'background':''"
               class="table">
            <span>{{v.name}}</span>
            <el-input v-model="v.oneself"
                      placeholder="请输入内容"
                      style="width:150px;"
                      :class="v.name==='金融投资收入'?'oneself':''"></el-input>
            <el-input v-model="v.spouse"
                      placeholder="请输入内容"
                      style="width:150px;"></el-input>
          </div>
        </el-main>
      </el-container>
      <el-container class="bottom">
        <el-header class="first-line"
                   style="height: 38px;">
          <span>年支出(元)</span>
          <span>本人</span>
          <span>配偶</span>
        </el-header>
        <el-main class="content">
          <div v-for="(v,i) in expenditureTableData"
               :key="i"
               :class="i%2!==0?'background':''"
               class="table">
            <span>{{v.name}}</span>
            <el-input v-model="v.oneself"
                      placeholder="请输入内容"
                      style="width:150px;"
                      :class="v.name==='贷款及利息支出'?'oneself':''"></el-input>
            <el-input v-model="v.spouse"
                      placeholder="请输入内容"
                      style="width:150px;"></el-input>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  props: ['incomeExpenditure', 'cis'],
  data() {
    return {
      incomeTableData: [
        {
          name: '工资收入',
          oneself: '',
          spouse: '',
        },
        {
          name: '金融投资收入',
          oneself: '',
          spouse: '',
        },
        {
          name: '其他收入',
          oneself: '',
          spouse: '',
        },
      ],
      expenditureTableData: [
        {
          name: '日常支出',
          oneself: '',
          spouse: '',
        },
        {
          name: '贷款及利息支出',
          oneself: '',
          spouse: '',
        },
        {
          name: '其他支出',
          oneself: '',
          spouse: '',
        },
      ],
    };
  },
  mounted() {
    this.getIncome();
  },
  methods: {
    getIncome() {
      const parames = {
        data: {
          cis: this.cis,
        },
      };
      this.$_post(this.$API.get_Income, parames).then((res) => {
        console.log(res);
        // 收入数据组装
        for (let i = 0; i < res.data.custIncomeInfos.length; i++) {
          for (let y = 0; y < this.incomeTableData.length; y++) {
            if (res.data.custIncomeInfos[i].isSelf === '0') {
              if (this.incomeTableData[y].name === '工资收入') {
                this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].salaryIncome;
              }
              if (this.incomeTableData[y].name === '金融投资收入') {
                this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].investIncome;
              }
              if (this.incomeTableData[y].name === '其他收入') {
                this.incomeTableData[y].oneself = res.data.custIncomeInfos[i].otherIncome;
              }
            } else {
              if (this.incomeTableData[y].name === '工资收入') {
                this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].salaryIncome;
              }
              if (this.incomeTableData[y].name === '金融投资收入') {
                this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].investIncome;
              }
              if (this.incomeTableData[y].name === '其他收入') {
                this.incomeTableData[y].spouse = res.data.custIncomeInfos[i].otherIncome;
              }
            }
          }
        }
        // 支出数据组装
        for (let i = 0; i < res.data.custExpend.custExpendInfo.length; i++) {
          for (let y = 0; y < this.expenditureTableData.length; y++) {
            if (res.data.custExpend.custExpendInfo[i].isSelf === '0') {
              if (this.expenditureTableData[y].name === '日常支出') {
                this.expenditureTableData[y].oneself = res.data.custExpend.custExpendInfo[i].dailyExpend;
              }
              if (this.expenditureTableData[y].name === '贷款及利息支出') {
                this.expenditureTableData[y].oneself = res.data.custExpend.custExpendInfo[i].loanInterestExpend;
              }
              if (this.expenditureTableData[y].name === '其他支出') {
                this.expenditureTableData[y].oneself = res.data.custExpend.custExpendInfo[i].otherExpend;
              }
            } else {
              if (this.expenditureTableData[y].name === '日常支出') {
                this.expenditureTableData[y].spouse = res.data.custExpend.custExpendInfo[i].dailyExpend;
              }
              if (this.expenditureTableData[y].name === '贷款及利息支出') {
                this.expenditureTableData[y].spouse = res.data.custExpend.custExpendInfo[i].loanInterestExpend;
              }
              if (this.expenditureTableData[y].name === '其他支出') {
                this.expenditureTableData[y].spouse = res.data.custExpend.custExpendInfo[i].otherExpend;
              }
            }
          }
        }
      });
    },
    preservation() {
      const parames = {
        data: {
          cis: this.cis,
          updateUser: '1', // 修改人
          custerIncomeInfoVOS: [ // 收入信息
            {
              isSelf: '0', // 是否本人，0本人，1配偶
              salaryIncome: this.incomeTableData[0].oneself, // 工资收入
              investIncome: this.incomeTableData[1].oneself, // 金融投资收入
              otherIncome: this.incomeTableData[2].oneself, // 其他收入
            },
            {
              isSelf: '1', // 是否本人，0本人，1配偶
              salaryIncome: this.incomeTableData[0].spouse, // 工资收入
              investIncome: this.incomeTableData[1].spouse, // 金融投资收入
              otherIncome: this.incomeTableData[2].spouse, // 其他收入
            },
          ],
          custerExpendInfoVOS: [ // ：支出信息
            {
              isSelf: '0', // 是否本人，0本人，1配偶
              dailyExpend: this.expenditureTableData[0].oneself, // 日常支出
              loanInterestExpend: this.expenditureTableData[1].oneself, // 贷款及利息支出
              otherExpend: this.expenditureTableData[2].oneself, // 其他支出
            },
            {
              isSelf: '1', // 是否本人，0本人，1配偶
              dailyExpend: this.expenditureTableData[0].spouse, // 日常支出
              loanInterestExpend: this.expenditureTableData[1].spouse, // 贷款及利息支出
              otherExpend: this.expenditureTableData[2].spouse, // 其他支出
            },
          ],
        },
      };
      this.$_post(this.$API.uptFinanceInfo, parames).then((res) => {
        if (res.errorCode === 'WP00035') {
          this.$message({
            message: res.errorMsg,
            type: 'success',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.Income-and-expenditureEdit {
  display: flex;
  flex-direction: row;
  .left {
    width: 49%;
    span {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      position: relative;
      top: 30px;
      left: 45px;
    }
  }
  .right {
    width: 100%;
    .top {
      height: 160px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 15px;
      .first-line {
        padding: 12px 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 1) !important;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          .oneself {
            position: relative;
            right: 14px;
          }
        }
      }
    }
    .bottom {
      height: 160px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 29px;
      .first-line {
        padding: 12px 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 1) !important;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          .oneself {
            position: relative;
            right: 21px;
          }
        }
      }
    }
  }
}
</style>
